import { all, call, put, takeLatest } from 'redux-saga/effects';

import { request } from '@app/services';
import { getOverdueTasks, getOverdueTasksFailed, getOverdueTasksSuccess } from './slice';
import * as endpoints from './endpoint';

function* getOverdueTasksSaga(action: ReturnType<typeof getOverdueTasks>): any {
  const { userId } = action.payload;

  try {
    const result = yield call(request.get, `${endpoints.overdueTasks}${userId}`);
    yield put(getOverdueTasksSuccess(result.data));
  } catch (err) {
    yield put(getOverdueTasksFailed(err));
  }
}

function* overdueTasksSagas() {
  yield all([takeLatest(getOverdueTasks, getOverdueTasksSaga)]);
}
export { overdueTasksSagas };
